import { StaticProvider } from '@angular/core';
import {
  DataLineageAclService,
  DataLineageGitService,
  DataLineageQuery,
  DataLineageService,
  DataLineageStore,
} from '@y42/data-lineage';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';

const DataLineageFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.Lineage,
    FEATURE_ROUTE: Y42Routes.Lineage,
    GIT_FOLDER: Y42GitFolders.Lineage,
    DETAIL_TABS: [],
    AbstractFeatureService: DataLineageService,
    AbstractFeatureQueryEntity: DataLineageQuery,
    AbstractFeatureEntityStore: DataLineageStore,
    AbstractFeatureGitService: DataLineageGitService,
    AbstractFeatureAclService: DataLineageAclService,
    AbstractFeatureChildQueryEntity: null,
  };
};

export function DataLineageProviders(): StaticProvider[] {
  return provideFeature(DataLineageFeatureProviders());
}
